import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { renderBetTypeName } from 'src/domains/players/webview/components/Account/betHistoryTab/betsList/betsList/betUtils';
import { BetHistoryType } from 'src/domains/players/webview/components/Account/betHistoryTab/BetHistoryTab.state';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { useCommon } from 'src/domains/common/Common';
import { UsersState } from 'src/domains/players/state/UsersState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsTypes {
    bet: BetHistoryType;
}

export const BetCombinedTypeStakeStatus = observer<PropsTypes>('BetCombinedTypeStakeStatus', ({ bet }) => {
    const common = useCommon();
    const { status } = bet;
    const languagesState = LanguagesState.get(common);
    const usersState = UsersState.get(common);
    const configComponents = ConfigComponents.get(common);

    return (
        <div>
            {`${renderBetTypeName(bet.type, configComponents.config, languagesState)} ${usersState.money(configComponents.precision.newFromAnything(bet.stakePerLine))} ${status}`}
        </div>
    );
});
